import React, { useState, useEffect } from 'react';
import Search from './Search';
import Grid from '@mui/material/Grid';

const SearchBar = ({ parentCallback }) => {
    const [data, setData] = useState({ 'etf1': {}, 'etf2': {} });

    const myCallback = (data, index) => {
        data ? getJson(data.value, index) : setInData({}, index);
    }
    const getJson = (ticker, index) => {
        fetch(`data/${ticker}.json`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            })
            .then((response) => response.json())
            .then((etf) => {
                etf['Ticker'] = ticker;
                setInData(etf, index);
            });
    }
    const setInData = (etf, index) => {
        setData(data => ({ ...data, [index]: etf }));
    }

    useEffect(() => {
        parentCallback(data);
    });

    return (
        <Grid
            container
            item
            justifyContent="space-evenly"
            spacing={2}
            sx={{ mb: 5 }}
        >
            <Grid item xs="auto">
                <Search parentCallback={myCallback} index={'etf1'} defaultEtf={'XEQT'} />
            </Grid>
            <Grid item xs="auto">
                <Search parentCallback={myCallback} index={'etf2'} defaultEtf={'VEQT'} />
            </Grid>
        </Grid>
    );
}

export default SearchBar;